// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text, Sprite, NineSlicePlane } from 'pixi.js';

const raw = {
  list: [
    {
      id: '3bfd5fce-81e5-48fc-a177-94b174156c66',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'bf1b26de-1e6f-46b3-baeb-7b6b13f35fe0',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3bfd5fce-81e5-48fc-a177-94b174156c66'
    },
    {
      id: '16bfe576-b609-4efe-b2da-77032946de02',
      type: 'Text',
      name: 'levelText',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '8',
      localize: false,
      maxWidth: 50,
      maxHeight: 60,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 54,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '#6F1F0C',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.45,
        dropShadowBlur: 0,
        dropShadowColor: '#6F1F0C',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '3bfd5fce-81e5-48fc-a177-94b174156c66'
    },
    {
      id: '3c9dc085-b6b0-47d0-b4fe-b5020d5d6a57',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Widget_Background_Blue',
      parent: 'bf1b26de-1e6f-46b3-baeb-7b6b13f35fe0'
    },
    {
      id: '865333a5-a538-45c4-a246-d75559667011',
      type: 'Sprite',
      name: 'flag',
      className: '',
      x: 0,
      y: -40,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Icon_Race_Flag',
      parent: 'bf1b26de-1e6f-46b3-baeb-7b6b13f35fe0'
    },
    {
      id: '838dc8a9-7e42-4efa-a9d9-7b25e0ae4cd0',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Streak_Icon_Node',
      parent: 'bf1b26de-1e6f-46b3-baeb-7b6b13f35fe0'
    },
    {
      id: '779d23b7-c8eb-4de6-abb9-edc421538080',
      type: 'Container',
      name: 'progressBar',
      className: '',
      x: 0,
      y: 37,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'bf1b26de-1e6f-46b3-baeb-7b6b13f35fe0'
    },
    {
      id: '80583312-03cd-4a70-934e-921da87719b8',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -45,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 90,
      height: 30,
      leftWidth: 28,
      topHeight: 28,
      rightWidth: 28,
      bottomHeight: 28,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_Progress_Bar_Background_3Slice_28x28',
      parent: '779d23b7-c8eb-4de6-abb9-edc421538080'
    },
    {
      id: '2cd6c0ea-0244-4321-897c-5b155ae6e8fa',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: -42,
      y: 3,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 84,
      height: 24,
      leftWidth: 17,
      topHeight: 17,
      rightWidth: 17,
      bottomHeight: 17,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_Progress_Bar_Main_Menu_Empty_3Slice_17x17',
      parent: '779d23b7-c8eb-4de6-abb9-edc421538080'
    },
    {
      id: '0e5d8c65-9def-4a7b-8fbd-d675745714c7',
      type: 'NineSlicePlane',
      name: 'progressBarFill',
      className: '',
      x: -42,
      y: 3,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 84,
      height: 24,
      leftWidth: 18,
      topHeight: 18,
      rightWidth: 18,
      bottomHeight: 18,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_Progress_Bar_Full_3Slice_18x18',
      parent: '779d23b7-c8eb-4de6-abb9-edc421538080'
    },
    {
      id: '81246714-fd26-42d1-a805-d1a70b085384',
      type: 'Text',
      name: 'progressText',
      className: '',
      x: 0,
      y: 14,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'X/Y',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#46130b',
        strokeThickness: 4,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '779d23b7-c8eb-4de6-abb9-edc421538080'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '2.0.0',
  handleResize: false
} as const;

export class WinStreakLoseProgressIconLayout {
  static raw = raw;
  root!: Container;
  levelText!: Text;
  flag!: Sprite;
  progressBar!: Container;
  progressBarFill!: NineSlicePlane;
  progressText!: Text;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
